export interface SourceProps {
    isAndroid: boolean;
    href: string;
}

export function judgeSource(): SourceProps {
    const userAgent = navigator.userAgent;
    console.log('userAgent', userAgent);

    const isAndroid = userAgent.indexOf('Android') > -1 || userAgent.indexOf('Linux') > -1 || userAgent.indexOf('HarmonyOS ') > -1;
    const isIOS = !!userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    // 是安卓浏览器

    let source: SourceProps = {
        isAndroid: isAndroid,
        href: ''
    }

    if (isAndroid) {
        source.href = 'https://play.google.com/store/apps/details?id=com.xingmai.tech';
    }
    // 是iOS浏览器
    if (isIOS) {
        source.href = 'https://apps.apple.com/us/app/beatbot/id6451108638';
    }

    // 是微信内部webView
    if (is_weixn()) {
        alert("请点击右上角按钮, 点击使用浏览器打开");
    }

    // 是PC端
    if (isPC()) {
        console.log('pc 跳转')
        source.href = 'https://beatbot.tech';
    }


    return source;
}

// 是微信浏览器
// function isWX(): boolean {
//     const ua: string = navigator.userAgent.toLowerCase();
//     return ua.indexOf("micromessenger") !== -1;
// }

function is_weixn() {
    var ua = navigator.userAgent.toLowerCase();
    return /MicroMessenger/i.test(ua);
}


function isPC(): boolean {
    const userAgent = navigator.userAgent;
    const mobileDevices = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];

    for (const device of mobileDevices) {
        if (userAgent.indexOf(device) > 0) {
            return false;
        }
    }

    return true;
}